import { get, omitBy } from "lodash/fp";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  Container,
  Content,
  FlexboxGrid,
  Footer,
  Header,
  Pagination,
  Table,
  Input,
  InputGroup,
} from "rsuite";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./StoreSchedules.css";
import { displayField, formatTimeField } from "../../../utils/helpers";
import CustomCell from "../../components/Elements/CustomCell";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

function PlayerStopTime({
  playerStopData,
  withHeader = true,
  ...props
}: {
  playerStopData?: any;
  withHeader?: boolean;
}) {
  const { t } = useTranslation();
  const { Cell, Column } = Table;
  const [loading, setLoading] = useState(false);
  const [compTotal, setCompTotal] = useState(playerStopData?.company?.length);
  const [compData, setCompData] = useState<any[]>([]);
  const [storeTotal, setStoreTotal] = useState(playerStopData?.store?.length);
  const [storeData, setStoreData] = useState<any[]>([]);
  const loggedInUserDetail = UtilityServices.getLoggedInUserDetails();

  function init() {
    setCompTotal(playerStopData?.company?.length);
    setCompData(playerStopData?.company);

    setStoreTotal(playerStopData?.store?.length);
    setStoreData(playerStopData?.store);
  }

  useEffect(() => {
    init();
  }, [playerStopData]);

  return (
    <div className="chart-songs">
      <Container className="container">
        <Header className="h4">
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item colspan={12}>
              <h4>
                {t("COMPANY")} {t("STOP")} {t("TIME")}
              </h4>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Header>

        <Content className="chart-songs">
          <div className={null}>
            <Table
              height={200}
              fillHeight={false}
              showHeader={true}
              data={compData}
              loading={loading}
              onSortColumn={null}
              sortColumn={null}
              bordered={true}
              cellBordered
              sortType={null}
              hover={true}
              renderEmpty={() => (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <h4>
                    {t("NO_ENTITY_FOUND_FOR", {
                      entity: t("RECORD"),
                      for:
                        t("COMPANY") +
                        " " +
                        t("PLAYER") +
                        " " +
                        t("STOP") +
                        " " +
                        t("TIME"),
                    })}
                  </h4>
                </div>
              )}
            >
              <Column width={200} align="center" fixed>
                <CustomHeaderCell>
                  {t("STOPS")} {t("AT")}
                </CustomHeaderCell>
                <CustomCell dataKey="stop_at">
                  {(rowData: any) => (
                    <span>
                      {formatTimeField(rowData?.stop_at, "12hr", false)}
                    </span>
                  )}
                </CustomCell>
              </Column>
              <Column width={200} align="center" fixed>
                <CustomHeaderCell>
                  {t("ENDS")} {t("AT")}
                </CustomHeaderCell>
                <CustomCell dataKey="stop_end_at">
                  {(rowData: any) => (
                    <span>
                      {formatTimeField(rowData?.stop_end_at, "12hr", false)}
                    </span>
                  )}
                </CustomCell>
              </Column>
              <Column flexGrow={1}>
                <CustomHeaderCell>{t("REASON")}</CustomHeaderCell>
                <CustomCell dataKey="reason" align="center">
                  {(rowData: any) => (
                    <span>{displayField(rowData?.reason)}</span>
                  )}
                </CustomCell>
              </Column>
            </Table>
          </div>
        </Content>
        <Footer className="footer">
          <Pagination
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={["total"]}
            total={compTotal}
          />
        </Footer>
        <Header className="h4">
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item colspan={12}>
              <h4>
                {t("STORE")} {t("STOP")} {t("TIME")}
              </h4>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Header>

        <Content className="chart-songs">
          <div className={null}>
            <Table
              height={200}
              fillHeight={false}
              showHeader={true}
              data={storeData}
              loading={loading}
              onSortColumn={null}
              sortColumn={null}
              bordered={true}
              cellBordered
              sortType={null}
              hover={true}
              renderEmpty={() => (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <h4>
                    {t("NO_ENTITY_FOUND_FOR", {
                      entity: t("RECORD"),
                      for:
                        t("STORE") +
                        " " +
                        t("PLAYER") +
                        " " +
                        t("STOP") +
                        " " +
                        t("TIME"),
                    })}
                  </h4>
                </div>
              )}
            >
              <Column width={200} align="center" fixed>
                <CustomHeaderCell>
                  {t("STOPS")} {t("AT")}
                </CustomHeaderCell>
                <CustomCell dataKey="stop_at">
                  {(rowData: any) => (
                    <span>
                      {formatTimeField(rowData?.stop_at, "12hr", false)}
                    </span>
                  )}
                </CustomCell>
              </Column>
              <Column width={200} align="center" fixed>
                <CustomHeaderCell>
                  {t("ENDS")} {t("AT")}
                </CustomHeaderCell>
                <CustomCell dataKey="stop_end_at">
                  {(rowData: any) => (
                    <span>
                      {formatTimeField(rowData?.stop_end_at, "12hr", false)}
                    </span>
                  )}
                </CustomCell>
              </Column>
              <Column flexGrow={1}>
                <CustomHeaderCell>{t("REASON")}</CustomHeaderCell>
                <CustomCell dataKey="reason" align="center">
                  {(rowData: any) => (
                    <span>{displayField(rowData?.reason)}</span>
                  )}
                </CustomCell>
              </Column>
            </Table>
          </div>
        </Content>
        <Footer className="footer">
          <Pagination
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={["total"]}
            total={storeTotal}
          />
        </Footer>
        <ToastContainer />
      </Container>
    </div>
  );
}

export default PlayerStopTime;
